import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { storeAccessToken } from '../../../services/data/accessToken'
import { setStep } from '../../../modules/registration/actions/creators'
import { setPrimaryInfo } from '../../../modules/profile/actions/creators'
import { setDevice } from '../../../modules/device/actions/creators'

import MainView from '../components/MainView/MainView'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}
const mapStateToProps = reduxState => {
  const { auth, profile, registration, device: deviceModule } = reduxState

  const { accessToken, redirectAfterAuth } = auth

  const { primaryInfo } = profile

  const { step } = registration

  const { browser } = deviceModule

  return {
    primaryInfo,
    step,
    accessToken,
    browser,
    redirectAfterAuth,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      setStep,
      push,
      setDevice,
      saveAccessToken,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
